import styled from 'styled-components'

export const CardOuter = styled.div`
  padding: 23px;
  position: relative;
  border-radius: 6px;
  box-shadow: 0 10px 14px 9px #cfd4dd;
  border: 1px solid #cfdbf5;
  background-color: #fbfbfb;
  min-width: ${({ cardWidth }) => (cardWidth ? cardWidth : 330)}px;
  width: ${({ cardWidth }) => (cardWidth ? cardWidth : 330)}px;

  height: ${({ cardHeight }) => (cardHeight ? cardHeight : 244)}px;
  @media only screen and (max-width: 660px) {
    height: 300px;
  }
  > svg {
    position: absolute;
    top: 9px;
    left: 0;
    opacity: 0;
  }
  margin: 0 1rem;
`

export const Card = styled.div`
  position: relative;

  .head {
    font-size: 35px;
    color: #cdcdcd;
    font-weight: 600;
    transform: translateY(50px);

    @media only screen and (max-width: 665px) {
      font-size: 30px;
    }
  }

  .sub {
    opacity: 0;
    position: absolute;
    font-weight: 500;
    color: #505050;
    font-size: 17px;
    line-height: 1.3;
    transform: translateY(50%);
  }
`
